import { getCups } from "./getCups";
import trackToString from "./trackToString";

/**
 * Get all available tracks for MK8DX for use in filter autocomplete
 */
export function getAllTracks() {
    const cupData = getCups();
    const tracks = [];
    
    cupData.forEach((cup, cupName) => {
        cup.tracks.forEach((track, index) => {
            tracks.push({
                name: trackToString(track),
                cupName: cupName,
                index: index
            });
        });
    });
    
    return tracks;
}
